import { Pipe, PipeTransform } from '@angular/core';

import { PieceProductSettings } from 'extensions/core/piece-product/front/models/piece-product.models';
import { ProductColor, ProductSize } from 'idt-ecommerce-api/catalog/products/products.models';
import { PRODUCT_SIZE_ADDITIONAL_INFO_DEFAULT_VALUE } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Pipe({
  name: 'thresholdLabel'
})
export class ThresholdLabelPipe implements PipeTransform {

  public transform(
    value: string[],
    threshold: string,
    piece: IdtComponent<PieceProductSettings>,
    hasStock: boolean,
    sizes?: ProductSize[]
  ): string {
    if (
      piece?.settings?.general.lastUnitsWarning && hasStock
      && (
        ((sizes?.length ?? 0) > 1 && sizes?.every((size) => size.typeThreshold?.includes(threshold)))
        || ((!sizes || sizes.length === 1) && value?.includes(threshold))
      )
    ) {
      return piece.settings.general.lastUnitsWarning;
    }

    return '';
  }

}

@Pipe({
  name: 'additionalInfo'
})
export class AdditionalInfoPipe implements PipeTransform {

  public transform(additionalInfo: string, piece: IdtComponent<PieceProductSettings>): string {
    if (piece?.settings?.general.additionalInfo) {
      const template = piece.settings.general.additionalInfo;
      return template.replace(/{{additionalInfo}}/g, additionalInfo);
    }
    return PRODUCT_SIZE_ADDITIONAL_INFO_DEFAULT_VALUE.replace(/{{additionalInfo}}/g, additionalInfo);
  }

}

@Pipe({
  name: 'viewSimilarProducts'
})
export class ViewSimilarProductsPipe implements PipeTransform {

  public transform(piece: IdtComponent<PieceProductSettings>, hasStock: boolean): string {
    if (piece?.settings?.general.viewSimilarProducts && !hasStock) {
      return piece.settings.general.viewSimilarProducts;
    }
    return '';
  }

}

@Pipe({
  name: 'colorSizes'
})
export class ColorSizesPipe implements PipeTransform {

  public transform(colors: ProductColor[], colorId?: string): ProductSize[] {
    const defaultSizes = colors[0].sizes || [];
    if (!colorId) {
      return defaultSizes;
    }
    return colors.find((color) => color.id === colorId)?.sizes || defaultSizes;
  }

}

@Pipe({
  name: 'sizeTypeLabel'
})
export class SizeTypePipe implements PipeTransform {

  public transform(
    size: string,
    piece: IdtComponent<PieceProductSettings>,
    isDescription: boolean
  ): string | undefined {
    switch (size) {
      case 'short':
        return isDescription
          ? piece?.settings?.general?.petiteSizeDescription
          : piece?.settings?.general?.petiteSizeText;
      case 'regular':
        return isDescription
          ? piece?.settings?.general?.regularSizeDescription
          : piece?.settings?.general?.regularSizeText;
      case 'long':
        return isDescription
          ? piece?.settings?.general?.tallSizeDescription
          : piece?.settings?.general?.tallSizeText;
      default:
        return size;
    }
  }

}

@Pipe({
  name: 'stockValue'
})
export class StockValuePipe implements PipeTransform {

  public transform(
    sizes: ProductSize[]
  ): boolean {
    return sizes.some((size) => (size.visibilityValue !== 'HIDDEN' && size.visibilityValue !== 'BACK_SOON' && size.visibilityValue !== 'COMING_SOON' && size.visibilityValue !== 'SOLD_OUT'));
  }

}

@Pipe({
  name: 'lastUnitsLabel'
})
export class LastUnitsPipe implements PipeTransform {

  public transform(
    sizes: ProductSize | ProductSize[],
    piece: IdtComponent<PieceProductSettings>
  ): string {
    const isLastUnits = Array.isArray(sizes) ? sizes.every((size) => size.visibilityValue === 'RUNNING_OUT') : sizes.visibilityValue === 'RUNNING_OUT';
    return isLastUnits && piece?.settings?.general?.lastUnitsWarning ? piece.settings.general.lastUnitsWarning : '';
  }

}
